import utils from "@src/common/utils";
import i18n from "@src/common/lib/i18n";
import {
  Dic
} from "@src/common/utils";
const tableOption = function () {
  let status = Dic.find("SENU080001");
  return {
    view: "预约详情",
    page: true,
    selection: true,
    index: true,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: "left",
    size: "small",
    maxHeight: "100%",
    labelWidth: "100px",
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: "700px",
    emptyText: "暂无数据",
    column: [{
        label: "姓名",
        prop: "name",
        search: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        overHidden: true,
        span: 12
      },
      {
        label: "电话",
        prop: "phone",
        editDisabled: false,
        addDisplay: true,
        editDisplay: true,
        overHidden: true,
        align: "center",
        minRows: 4,
        maxlength: 50,
        span: 12
      },
      {
        label: "身份证号",
        prop: "idCard",
        align: "center",
        type: "select",
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 12
      },
      {
        label: "车牌号",
        prop: "plateCode",
        type: "text",
        value: "",
        search: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        span: 12
      },
      {
        label: "申请时间",
        prop: "createTime",
        type: "datetimerange",
        value: "",
        searchSlot: true,
        search: true,
        span: 12
      },
      {
        label: "申请入厂时间",
        prop: "enterTime",
        type: "datetime",
        value: "",
        // search: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        span: 12
      },
      {
        label: "来访事由",
        prop: "visitorReason",
        span: 12,
        align: "center",
        hide: true
      },
      {
        label: "申请出厂时间",
        prop: "exitTime",
        type: "datetime",
        // search: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        valueFormat: "timestamp",
        span: 12,
        align: "center"
        // formatter: function (row, value) {
        //   return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        // }
      },
      {
        label: "人脸照片",
        prop: "fileCode",
        span: 24,
        type: "textarea",
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        align: "center",
        minRows: 5,
        minlength: 2,
        maxlength: 50
      },
      {
        label: "有效证件照",
        prop: "idCardFileCode",
        span: 24,
        type: "textarea",
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        align: "center",
        minRows: 5,
        minlength: 2,
        maxlength: 50
      },
      {
        label: "审批状态",
        prop: "status",
        type: "select",
        search: true,
        searchPlaceholder: "选择审批状态",
        span: 24,
        dicData: Dic.find("SENU080001"),
        // el.label != "已签离" &&
        // el.label != "签离超时"
        // dicData: status.filter((el) => {
        //   if (
        //     el.label !== "结束" &&
        //     el.label != "已签到" &&
        //     el.label != "签到超时"
        //   ) {
        //     return el;
        //   }
        // }),
        viewFormatter: (row, value) => {
          if (value) {
            return Dic.findByValue("SENU080001", Number(value));
          }
          return "";
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue("SENU080001", value) : "";
        }
      },
      {
        label: "审批意见",
        prop: "remark",
        span: 24
      }
    ]
  };
};
export default tableOption;